module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm', {
    attrs: {
      "title": _vm.title,
      "mask-close": _vm.maskClose,
      "has-close": _vm.hasClose,
      "can-scroll": _vm.canScroll,
      "is-double-btn": false,
      "confirm-text": _vm.btnText
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      },
      "on-confirm": function($event) {
        _vm.$emit('on-sure')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37a84042", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a84042"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@finance/ssvue/src/components/alert/index.vue
// module id = 256
// module chunks = 8